<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="leftDrawer"
      temporary
      fixed
      app
      v-if="showNavigation"
    >
      <v-list dense>
        <v-list-tile :to="{ path:'/' }">
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Записи</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-group prepend-icon="settings">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>Настройки</v-list-tile-title>
            </v-list-tile>
          </template>

          <v-list-tile :to="{ path:'/auth-setup' }">
            <v-list-tile-action></v-list-tile-action>
            <v-list-tile-title>Авторизация</v-list-tile-title>
          </v-list-tile>

          <v-list-tile :to="{ path:'/profile-setup' }">
            <v-list-tile-action></v-list-tile-action>
            <v-list-tile-title>Профиль</v-list-tile-title>
          </v-list-tile>

          <v-list-tile :to="{ path:'/page-setup' }">
            <v-list-tile-action></v-list-tile-action>
            <v-list-tile-title>Страница подтверждения</v-list-tile-title>
            <!-- <v-list-tile-action style="justify-content: flex-end;color:red;">NEW</v-list-tile-action> -->
          </v-list-tile>

          <v-list-tile :to="{ path:'/automation' }">
            <v-list-tile-action></v-list-tile-action>
            <v-list-tile-title>Автоматизация</v-list-tile-title>
          </v-list-tile>
        </v-list-group>

        <v-list-tile :to="{ path:'/account' }">
          <v-list-tile-action>
            <v-icon>account_circle</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Мой аккаунт</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile :to="{ path:'/payment' }">
          <v-list-tile-action>
            <v-icon>payment</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Тарифы</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile :to="{ path:'/contact' }">
          <v-list-tile-action>
            <v-icon>people</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Контакты</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="logout">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Выйти</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-model="rightDrawer"
      temporary
      fixed
      right
      app
      :width="windowWidth"
      v-if="showNavigation"
    >
      <Help v-on:close="toggleHelp" v-if="rightDrawer"/>
    </v-navigation-drawer>

    <v-toolbar color="#4169E1" dark fixed app v-if="showNavigation">
      <v-toolbar-side-icon @click.stop="leftDrawer = !leftDrawer"></v-toolbar-side-icon>
      <v-toolbar-title>Evriday</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-toolbar-side-icon @click.stop="rightDrawer = !rightDrawer"> -->
      <v-toolbar-side-icon @click="toggleHelp">
        <v-icon medium dark>help</v-icon>
      </v-toolbar-side-icon>
    </v-toolbar>

    <v-content>
      <Snackbar />
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import Snackbar from './components/Snackbar'
import Help from './components/Help'

export default {
  name: 'App',
  components: {
    Snackbar,
    Help
  },
  data: () => ({
    admins: [
      ['Management', 'people_outline'],
      ['Settings', 'settings']
    ],
    leftDrawer: false,
    rightDrawer: false
  }),
  computed: {
    showNavigation () {
      return this.$store.state.navigation
    },
    windowWidth () {
      return window.innerWidth < 600 ? window.innerWidth : window.innerWidth / 2
    }
  },
  methods: {
    toggleHelp: function () {
      this.rightDrawer = !this.rightDrawer
    },
    logout: function () {
      this.leftDrawer = false
      this.rightDrawer = false
      this.$store.dispatch('appLogout')
    }
  }
}
</script>
